import React from "react";
const Nbsp = () => <>{"\u00A0"}</>;
export default Nbsp;
